export type GalleryCategory = "写真" | "活动" | "宣传照";

export interface GalleryItem {
  id: string;
  category: GalleryCategory;
  title: string;
  date: string;
  image: string;
  caption: string;
  ratio: "portrait" | "landscape" | "square";
}

export const galleryList: GalleryItem[] = [
  {
    id: "g001",
    category: "写真",
    title: "暖灰影棚 · 封面写真",
    date: "2026-10-15",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20an%20elegant%20Asian%20woman%20in%20her%20forties%20in%20a%20cream%20silk%20shirt%2C%20seated%20on%20a%20simple%20wooden%20stool%20against%20a%20warm%20grey%20studio%20backdrop%2C%20soft%20window%20light%20from%20the%20left%2C%20calm%20confident%20gaze%2C%20fine%20film%20grain%2C%20minimal%20high%20fashion%20photography&width=900&height=1200&seq=cecilia-gallery-001&orientation=portrait",
    caption: "为杂志封面拍摄的一组素色写真，光从左侧斜切入，保留了皮肤的自然质感。",
    ratio: "portrait",
  },
  {
    id: "g002",
    category: "写真",
    title: "窗边侧影",
    date: "2026-10-15",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20portrait%20of%20an%20Asian%20woman%20in%20profile%20standing%20beside%20a%20large%20window%20in%20a%20minimal%20room%2C%20sheer%20curtain%20diffusing%20morning%20light%2C%20beige%20linen%20dress%2C%20gentle%20shadow%20across%20her%20face%2C%20warm%20neutral%20palette%2C%20editorial%20film%20photography&width=900&height=1200&seq=cecilia-gallery-002&orientation=portrait",
    caption: "拍摄间隙被摄影师抓下的一张侧影，窗帘滤过的光线把整个房间都变柔了。",
    ratio: "portrait",
  },
  {
    id: "g003",
    category: "活动",
    title: "上海品牌之夜",
    date: "2026-10-08",
    image:
      "https://readdy.ai/api/search-image?query=Event%20photography%20of%20an%20elegant%20Asian%20woman%20in%20a%20tailored%20ivory%20suit%20walking%20in%20a%20bright%20minimalist%20gallery%20space%20with%20warm%20wood%20floor%2C%20soft%20diffused%20lighting%2C%20cream%20and%20beige%20interior%2C%20candid%20confident%20pose&width=1200&height=800&seq=cecilia-gallery-003&orientation=landscape",
    caption: "上海品牌活动现场，米白色西装搭配极简配饰，全程几乎没有多余手势。",
    ratio: "landscape",
  },
  {
    id: "g004",
    category: "宣传照",
    title: "《南方来信》主视觉",
    date: "2026-10-11",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20a%20quiet%20drama%20film%2C%20a%20woman%20in%20a%20beige%20knit%20sweater%20standing%20in%20the%20doorway%20of%20an%20old%20bookshop%2C%20warm%20lamplight%20spilling%20out%2C%20rain%20on%20the%20street%2C%20muted%20brown%20and%20amber%20palette%2C%20elegant%20minimal%20composition%20with%20negative%20space%20at%20top&width=900&height=1200&seq=cecilia-gallery-004&orientation=portrait",
    caption: "影片主视觉选用书店门口的一张定妆照，画面刻意保留了大面积的暗部。",
    ratio: "portrait",
  },
  {
    id: "g005",
    category: "写真",
    title: "旧屋与光",
    date: "2026-09-28",
    image:
      "https://readdy.ai/api/search-image?query=Moody%20interior%20portrait%20of%20an%20Asian%20woman%20in%20a%20rust%20colored%20knit%20cardigan%20sitting%20in%20an%20old%20wooden%20room%20with%20dusty%20sunlight%20streaming%20through%20shutters%2C%20warm%20sepia%20and%20terracotta%20tones%2C%20quiet%20cinematic%20mood&width=1200&height=800&seq=cecilia-gallery-005&orientation=landscape",
    caption: "在一栋老屋里拍摄的一组氛围写真，全部采用自然光，未使用补光器材。",
    ratio: "landscape",
  },
  {
    id: "g006",
    category: "活动",
    title: "公益课堂现场",
    date: "2026-09-19",
    image:
      "https://readdy.ai/api/search-image?query=Documentary%20photograph%20of%20a%20sunlit%20rural%20school%20classroom%20with%20wooden%20desks%20and%20children%20books%2C%20a%20woman%20in%20a%20simple%20blue%20shirt%20kneeling%20beside%20a%20desk%2C%20warm%20morning%20light%20through%20windows%2C%20gentle%20hopeful%20atmosphere%2C%20earthy%20palette&width=1200&height=800&seq=cecilia-gallery-006&orientation=landscape",
    caption: "乡村小学的表演课上，她蹲下来和孩子们平视着说话。",
    ratio: "landscape",
  },
  {
    id: "g007",
    category: "写真",
    title: "白色空间",
    date: "2026-09-10",
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20square%20portrait%20of%20an%20Asian%20woman%20in%20a%20white%20cotton%20shirt%20against%20a%20warm%20off%20white%20wall%2C%20soft%20even%20lighting%2C%20natural%20undone%20hair%2C%20calm%20expression%2C%20subtle%20warm%20shadow%20on%20one%20side%2C%20clean%20editorial%20studio%20photography&width=900&height=900&seq=cecilia-gallery-007&orientation=squarish",
    caption: "极简棚拍，服装只有一件白衬衫，妆面几乎只做了肤色统一。",
    ratio: "square",
  },
  {
    id: "g008",
    category: "宣传照",
    title: "香氛形象大片",
    date: "2026-08-28",
    image:
      "https://readdy.ai/api/search-image?query=Luxury%20fragrance%20campaign%20image%20of%20an%20Asian%20woman%20in%20a%20soft%20cream%20tailored%20dress%20holding%20a%20glass%20perfume%20bottle%2C%20seated%20at%20a%20beige%20stone%20table%20with%20dried%20flowers%2C%20warm%20directional%20lighting%2C%20oriental%20minimal%20aesthetic%2C%20amber%20and%20ivory%20palette&width=1200&height=800&seq=cecilia-gallery-008&orientation=landscape",
    caption: "品牌亚太区代言形象大片，主题是「慢下来的香气」。",
    ratio: "landscape",
  },
  {
    id: "g009",
    category: "活动",
    title: "小剧场见面会",
    date: "2026-08-12",
    image:
      "https://readdy.ai/api/search-image?query=Intimate%20small%20theater%20meeting%20photo%20with%20warm%20amber%20stage%20lighting%2C%20wooden%20seats%20in%20soft%20focus%2C%20a%20woman%20in%20a%20simple%20white%20shirt%20standing%20on%20a%20small%20stage%20holding%20a%20letter%2C%20terracotta%20curtains%2C%20cozy%20cinematic%20mood&width=1200&height=800&seq=cecilia-gallery-009&orientation=landscape",
    caption: "见面会以读信和问答为主，现场没有主持人串场。",
    ratio: "landscape",
  },
  {
    id: "g010",
    category: "写真",
    title: "午后庭院",
    date: "2026-07-30",
    image:
      "https://readdy.ai/api/search-image?query=Relaxed%20portrait%20of%20an%20Asian%20woman%20in%20a%20loose%20linen%20dress%20standing%20in%20a%20sunlit%20courtyard%20with%20olive%20trees%20and%20terracotta%20pots%2C%20warm%20late%20afternoon%20light%2C%20soft%20shadow%20patterns%20on%20the%20wall%2C%20earthy%20natural%20palette&width=900&height=1200&seq=cecilia-gallery-010&orientation=portrait",
    caption: "庭院写真拍摄于一个没有风的下午，整组照片几乎没有修图。",
    ratio: "portrait",
  },
  {
    id: "g011",
    category: "宣传照",
    title: "《忘不了》修复版海报",
    date: "2026-09-27",
    image:
      "https://readdy.ai/api/search-image?query=Nostalgic%20reissue%20movie%20poster%20with%20a%20young%20woman%20in%20a%20white%20shirt%20seen%20from%20behind%20looking%20out%20at%20a%20wet%20neon%20lit%20hong%20kong%20street%20at%20night%2C%20warm%20amber%20and%20teal%20highlights%2C%20soft%20film%20grain%2C%20nineteen%20nineties%20cinema%20aesthetic&width=900&height=1200&seq=cecilia-gallery-011&orientation=portrait",
    caption: "修复版重映海报，保留了原始胶片颗粒与当年的字体设计。",
    ratio: "portrait",
  },
  {
    id: "g012",
    category: "活动",
    title: "剧组定妆日",
    date: "2026-07-14",
    image:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20photo%20of%20a%20film%20makeup%20room%20with%20mirrors%20bordered%20by%20warm%20bulbs%2C%20wooden%20counter%20with%20brushes%20and%20costume%20pieces%2C%20soft%20amber%20light%2C%20empty%20stool%2C%20warm%20nostalgic%20cinematic%20atmosphere&width=1200&height=800&seq=cecilia-gallery-012&orientation=landscape",
    caption: "《南方来信》定妆日，妆发不到四十分钟完成。",
    ratio: "landscape",
  },
  {
    id: "g013",
    category: "写真",
    title: "胶片中的她",
    date: "2026-07-02",
    image:
      "https://readdy.ai/api/search-image?query=Analog%20film%20square%20portrait%20of%20an%20Asian%20woman%20in%20a%20beige%20blazer%20standing%20against%20a%20weathered%20cream%20wall%2C%20natural%20soft%20light%2C%20slight%20overexposure%20on%20one%20side%2C%20warm%20muted%20colors%2C%20unposed%20candid%20expression%2C%20thirty-five%20millimeter%20texture&width=900&height=900&seq=cecilia-gallery-013&orientation=squarish",
    caption: "使用古董胶片机拍摄，一卷只有三十多张，最后留下九张。",
    ratio: "square",
  },
  {
    id: "g014",
    category: "宣传照",
    title: "《一屋三餐》定档海报",
    date: "2026-10-02",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20lifestyle%20show%20poster%20of%20a%20cozy%20old%20house%20kitchen%20with%20steaming%20pots%2C%20wooden%20table%20set%20for%20three%2C%20warm%20morning%20sunlight%20through%20window%2C%20ceramic%20bowls%20and%20fresh%20herbs%2C%20inviting%20homely%20atmosphere%2C%20beige%20and%20terracotta%20palette&width=1200&height=800&seq=cecilia-gallery-014&orientation=landscape",
    caption: "节目定档海报，取景于老屋的厨房，桌上三副碗筷呼应节目名字。",
    ratio: "landscape",
  },
  {
    id: "g015",
    category: "写真",
    title: "夜与霓虹",
    date: "2026-06-21",
    image:
      "https://readdy.ai/api/search-image?query=Night%20portrait%20of%20an%20Asian%20woman%20in%20a%20black%20tailored%20coat%20standing%20on%20a%20quiet%20hong%20kong%20street%20with%20warm%20neon%20reflections%20on%20wet%20pavement%2C%20deep%20shadows%20with%20amber%20highlights%2C%20moody%20cinematic%20photography%2C%20film%20grain&width=900&height=1200&seq=cecilia-gallery-015&orientation=portrait",
    caption: "夜街写真，几乎没有使用闪光灯，全部依靠街边的霓虹与招牌光。",
    ratio: "portrait",
  },
];